import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGN_SUCCESS:
      return action.campaign;
    default:
      return state;
  }
}
